/* eslint-disable no-unused-vars */
function isSet(value) {
	if (value !== null && value !== undefined && value !== '') return true;
	else return false;
}

function isArray(what) {
	return Object.prototype.toString.call(what) === '[object Array]';
}

function isJsonString(str) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}

function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

function isIE() {
	if (typeof window !== 'undefined') {
		let agent = window.navigator.userAgent;

		if (agent.indexOf('Edge') > -1 || agent.indexOf('Trident') > -1 || agent.indexOf('MSIE') > -1) return true;
		else return false;
	}
	else {
		return false;
	}
}

function blob2file(data, fileName) {
	var blob = new Blob([data], { type: 'application/octetstream' });					
	var link = URL.createObjectURL(blob);					
	var a = document.createElement("a");
	a.setAttribute("download", fileName);
	a.setAttribute("href", link);
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(link);
}

export { isSet, isArray, isJsonString, isIE, blob2file };